module.exports = __webpack_public_path__ + "static/05.33680ac1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/soon/05.svg
// module id = 994
// module chunks = 35783957827783